import { render, staticRenderFns } from "./memberCert.vue?vue&type=template&id=2bd79f06&scoped=true&"
import script from "./memberCert.vue?vue&type=script&lang=js&"
export * from "./memberCert.vue?vue&type=script&lang=js&"
import style0 from "./memberCert.vue?vue&type=style&index=0&id=2bd79f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd79f06",
  null
  
)

export default component.exports